import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">分类索引</h2>
          <div className="w-12 h-1 bg-accent-500 mx-auto rounded-full"></div>
          <p className="text-sm text-foreground-500 mt-3">按类型快速找到你想看的影片</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.map((item, idx) => (
            <a
              key={item.id}
              href="#"
              className="group flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors duration-300 ${
                idx % 3 === 0 ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50' :
                idx % 3 === 1 ? 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50' :
                'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50'
              }`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 mb-0.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <div className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.count}</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}